export class InterestService{
    serviceTypcode: string;
    portfolioId: number
}